<script>
import { buttonsConfig, transcodificableContents } from '../../config';
import HeaderVideoButton from '@/modules/content/editor/components/buttons/HeaderVideoButton';
import MileniumPositionEditorButtons from '@/modules/milenium/components/form/MileniumEditorButtons';

export default {
  functional: true,
  name: 'nx-content-editor-header-buttons',
  props: {
    type: String,
    channel: String,
    disabled: Boolean,
    component: [Object, String],
  },
  render(createElement, context) {
    const createComponent = comp => createElement(comp, {
      props: { disabled, type, channel },
      on: context.listeners,
    });

    const {
      disabled, type, channel, component,
    } = context.props;

    if (component) {
      return createComponent(component);
    }
    if (channel === 'print') {
      return createComponent(MileniumPositionEditorButtons);
    }
    if (transcodificableContents.includes(type)) {
      return createComponent(HeaderVideoButton);
    }
    return createComponent(buttonsConfig.component);
  },
};
</script>
